/* eslint-disable max-classes-per-file */
import barba from '@barba/core';
import barbaCss from '@barba/css';
import barbaPrefetch from '@barba/prefetch';
import barbaRouter from '@barba/router';
import { Module } from 'ovee.js';
const defaultOptions = {
    useCss: false,
    useRouter: false,
    usePrefetch: true,
};
export default class extends Module {
    get hooks() {
        var _a;
        return (_a = this.options.hooks) !== null && _a !== void 0 ? _a : {};
    }
    init() {
        this.options = Object.assign(Object.assign({}, defaultOptions), this.options);
        this.usePrefetch();
        this.useCss();
        this.useRouter();
        barba.init(this.options);
        this.initHooks();
        this.$app.$go = (...args) => barba.go(...args);
        this.$app.$prefetch = (...args) => barba.prefetch(...args);
    }
    destroy() {
        super.destroy();
        barba.destroy();
    }
    usePrefetch() {
        if (this.options.usePrefetch) {
            barba.use(barbaPrefetch);
        }
    }
    useCss() {
        if (this.options.useCss) {
            barba.use(barbaCss);
        }
    }
    useRouter() {
        const { useRouter, routes } = this.options;
        if (useRouter) {
            barba.use(barbaRouter, { routes });
        }
    }
    initHooks() {
        this.registerHook('before');
        this.registerHook('beforeLeave', 'before-leave');
        this.registerHook('leave');
        this.registerHook('afterLeave', 'after-leave');
        this.registerHook('beforeEnter', 'before-enter');
        barba.hooks.enter(data => {
            const { next } = data !== null && data !== void 0 ? data : {};
            const { bodyClass } = next.container.dataset;
            this.$app.getConfig().document.body.classList.value = bodyClass !== null && bodyClass !== void 0 ? bodyClass : '';
            this.callHook('enter');
        });
        this.registerHook('afterEnter', 'after-enter');
        this.registerHook('after');
    }
    registerHook(name, appName) {
        barba.hooks[name](() => this.callHook(name, appName));
    }
    callHook(name, appName) {
        var _a, _b;
        // eslint-disable-next-line no-unused-expressions
        (_b = (_a = this.hooks)[name]) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.$app.$emit(`barba:${appName !== null && appName !== void 0 ? appName : name}`);
    }
    static getName() {
        return 'OveeBarba';
    }
}
